<template>
    <section id="header" class="text-center text-nowrap">
        <img alt="logo-tds" class="logo" src="/assets/images/tds-logo.png" />
        <img alt="logo-tims" class="logo" src="/assets/images/tims-logo.png" />
    </section>
    <section id="content">
        <div class="container">
            <main class="mb-5">
                <router-view />
            </main>
        </div>
    </section>
    <section id="footer" class="text-center">
        <div class="container">
            <div>
                <img alt="logo-tds" class="footer-logo" src="/assets/images/tds-logo.png" />
                <small class="d-block">Copyright © 2025, Tourism Development Department</small>
            </div>
        </div>
    </section>
</template>


<style scoped>
#header {
    padding: 80px 0;
    background-image: linear-gradient(rgb(255 255 255 / 10%), rgb(255 255 255)),
        url('/assets/images/survey-bg.jpeg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

#header .logo {
    max-height: 180px;
}

#content {
    margin-top: -1px;
    background: #fff;
}

#footer {
    height: 200px;
}

#footer .footer-logo {
    height: 150px;
}
</style>
